const en = {
  search: 'Search',
  loginTimeOut: 'Please log in again after login timeout!',
  serveError: 'Server error, please contact the administrator!',
  inRequestNotRepeat: 'In request, please do not repeat the operation',

  // 提示
  noEmpty: ' cannot be empty',
  enterCorrent: 'Please enter the correct ',

  //登录
  inputCorrectEmail: 'Please input the correct email address',
  emailAddress: 'Email address',
  username: 'Username',
  login: 'Login',
  password: 'Password',

  notExceed: 'File must not exceed ',
  uploadFileFail: 'File upload failed. Please try again later',
  isWrongType: 'The file type is incorrect!',

  publisherLogo: 'Publisher Logo',
  publisherFullName: 'Publisher’s Full Name',
  publisherAbbreviation: 'Publisher’s Abbreviation',
  themeColor: 'Theme Color',
  downloadNum: 'Download in Total',
  articleNum: 'Manuscript in Total',
  readNum: 'View in Total',
  country: 'Country',
  publisherAddress: 'Publisher‘s Address',
  officialWebsite: 'Official Website',
  termsCondition: 'Terms & Condition',
  termsUse: 'Terms & Use',
  upload: 'Upload',
  customsizeColor: 'Customize Color',
  basiceInformation: 'Basice information',
  twitter: 'Twitter',
  facebook: 'Facebook',
  linkedin: 'Linkedin',
  copyright: 'Copyright',
  preview: 'Save & Preview',
  submit: 'Submit',

  YouHaventCreatedAnyRecordYet: 'You haven’t created any record yet.',
  textToLong: 'The text is too long'
}

export default en
